import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Typography from 'components/atoms/Typography'
import CardPhone from 'components/molecules/CardPhone'
import { get } from 'lodash'

function PhoneTags({ data }) {
  const title = get(data, 'title')
  const items = get(data, 'items')

  return (
    <Container fluid="fluid" className="bg-gray-400">
      <Container className="pb-3 pb-lg-5">
        {title && (
          <Row className="mt-1 mt-md-3">
            <Col sm={12} className="">
              <Typography variant="h3" color="primary" cssClass="title-bold-md text-center">
                {title}
              </Typography>
            </Col>
          </Row>
        )}
        <Row>
          {items &&
            items.map(({ entity }, index) => {
              return (
                <Col sm={12} md={4} className="clear-height" key={get(entity, 'uuid')}>
                  <CardPhone
                    type="primary"
                    iconFont={false}
                    icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                    description={get(entity, 'description.value')}
                    maxLine={3}
                    text={get(entity, 'text')}
                  />
                </Col>
              )
            })}
        </Row>
      </Container>
    </Container>
  )
}

export default PhoneTags
